// extracted by mini-css-extract-plugin
export default {"card":"selectedcard_card__I7ynh","top":"selectedcard_top__e7QyX","list":"selectedcard_list__fO+PH","item":"selectedcard_item__pMATo","grad_icon":"selectedcard_grad_icon__G+fRm"};